
import { computed, defineComponent, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Actions } from "@/store/enums/StoreEnums";
import { Field } from "vee-validate";
import moment from "moment";

export default defineComponent({
  name: "user-role-modal",
  components: {
    Field,
  },
  methods: {
    moment(date) {
      return moment(date).format("MMM DD YYYY, h:mm a");
    },
  },
  setup() {
    const store = useStore();
    const tableCallFunction = Actions.GET_USERS;
    const loading = ref<boolean>(false);

    const currentUserEdit = computed(() => {
      return store.getters.currentUserEdit;
    });

    const superAdmin = ref<string>("");
    const admin = ref<string>("");
    const faculty = ref<string>("");
    const irbchair = ref<string>("");
    const irbmember = ref<string>("");
    const staff = ref<string>("");
    const student = ref<string>("");

    const changeCheckbox = (role, value) => {
      const notCotinueExecition =
        superAdmin?.value != "1" &&
        admin?.value != "1" &&
        faculty?.value != "1" &&
        irbchair?.value != "1" &&
        irbmember?.value != "1" &&
        staff?.value != "1" &&
        student?.value != "1";
      if (notCotinueExecition) {
        Swal.fire({
          text: "Select at least one role",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Ok, got it!",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          return;
        });
      }
      if (notCotinueExecition) {
        return;
      }
      const json = {
        userId: currentUserEdit.value.idUser,
        role: role,
      };

      if (value === "1") {
        store
          .dispatch(Actions.ADMIN_ASSIGN_ROLE, json)
          .then(() => {
            Swal.fire({
              text: store.getters.getAdminMessage,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            }).then(() => {
              store.dispatch(tableCallFunction, {
                params: {
                  Page: 1,
                  RecordsPerPage: 8,
                  piEmail: currentUserEdit?.value?.piEmail,
                },
              });
            });
          })
          .catch(() => {
            Swal.fire({
              text: store.getters.getAdminMessage,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          });
      } else {
        store
          .dispatch(Actions.ADMIN_REMOVE_ROLE, json)
          .then(() => {
            Swal.fire({
              text: store.getters.getAdminMessage,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            }).then(() => {
              store.dispatch(tableCallFunction, {
                params: {
                  Page: 1,
                  RecordsPerPage: 8,
                  piEmail: currentUserEdit?.value?.piEmail,
                },
              });
            });
          })
          .catch(() => {
            Swal.fire({
              text: store.getters.getAdminMessage,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          });
      }
    };

    watchEffect(() => {
      const data = store.getters.currentUserEdit;
      if (data === null) return;
      console.log("watch effect");
      console.log(data);
      if (data.piRole) {
        const roles: string[] = data.piRole.replace(/ /g, "").split(",");
        console.log("roles");
        if (roles.includes("superadmin")) {
          superAdmin.value = "1";
        } else {
          superAdmin.value = "0";
        }

        if (roles.includes("admin")) {
          admin.value = "1";
        } else {
          admin.value = "0";
        }

        if (roles.includes("faculty")) {
          faculty.value = "1";
        } else {
          faculty.value = "0";
        }

        if (roles.includes("irbchair")) {
          irbchair.value = "1";
        } else {
          irbchair.value = "0";
        }

        if (roles.includes("irbmember")) {
          irbmember.value = "1";
        } else {
          irbmember.value = "0";
        }

        if (roles.includes("staff")) {
          staff.value = "1";
        } else {
          staff.value = "0";
        }

        if (roles.includes("student")) {
          student.value = "1";
        } else {
          student.value = "0";
        }
      }
    });

    return {
      changeCheckbox,
      currentUserEdit,
      loading,
      superAdmin,
      admin,
      faculty,
      irbchair,
      irbmember,
      staff,
      student,
    };
  },
});
